export default __webpack_public_path__ + "static/media/plausible-logo.d9dc5d2c.png";